@if (optimized) {
  @if (!fill) {
    <img
      [class]="styleClasses"
      [ngSrc]="image?.cdnBasePath"
      [alt]="image.alt"
      [width]="imageWidth ?? undefined"
      [height]="imageHeight ?? undefined"
      [priority]="priority"
      [loading]="priority ? undefined : 'lazy'"
    />
  } @else {
    <img
      [class]="styleClasses"
      [ngSrc]="image?.cdnBasePath"
      [alt]="image.alt"
      [priority]="priority"
      [loading]="priority ? undefined : 'lazy'"
      [fill]="true"
    />
  }
} @else {
  <img
    [class]="styleClasses"
    [src]="src"
    [alt]="image.alt"
    [attr.width]="imageWidth ?? undefined"
    [attr.height]="imageHeight ?? undefined"
    [loading]="priority ? undefined : 'lazy'"
  />
}
